/* PC Car Problems. Self-contained; loaded only on /pages/car-problems/<handle>. No shared dependencies. */
(function () {
  'use strict';

  /* ---------- compute: PURE. No DOM, no network. ---------- */
  function compute(doc, year, ctx) {
    var keys = Object.keys(doc.years).sort();
    var i = keys.indexOf(String(year));
    if (i < 0) { i = keys.indexOf(String((doc.worst || [])[0])); if (i < 0) i = keys.length - 1; year = keys[i]; }
    var d = doc.years[year], rows = [], k, c, m, pct, href;
    for (k = 0; k < d.comp.length; k++) {
      c = d.comp[k]; m = doc.components[c[0]] || { label: c[0], parts: '', handle: null, mode: 'none', hidden: 0 };
      pct = d.n ? Math.round(100 * c[1] / d.n) : 0;
      href = null; var bare = false;
      if (m.mode === 'shop' && ctx.partsLinks && m.handle && (c[3] || 0) > 0) {
        href = '/collections/' + m.handle + '?year=' + year + '&make=' + encodeURIComponent(ctx.acesMake) + '&model=' + encodeURIComponent(ctx.acesModel);
      } else if (m.mode === 'shop' && m.handle && (m.products || 0) > 0) {
        href = '/collections/' + m.handle; bare = true;
      }
      rows.push({ key: c[0], label: m.label, parts: m.parts || '', pct: pct, n: c[1], crashes: c[2], mode: m.mode, href: href, bare: bare, hidden: !!m.hidden });
    }
    var years = [];
    for (k = 0; k < keys.length; k++) {
      years.push({ year: keys[k], n: doc.years[keys[k]].n, top: (doc.years[keys[k]].comp[0] || [null])[0] });
    }
    return { year: year, prev: i > 0 ? keys[i - 1] : null, next: i < keys.length - 1 ? keys[i + 1] : null, n: d.n,
             rows: rows, side: { crash: d.crash, fire: d.fire, inj: d.inj, miles: d.miles, recalls: d.recalls }, years: years };
  }
  /* Heckbert's "nice numbers": round a raw interval to 1, 2, 5 or 10 times a power of ten. */
  function niceNum(range, round) {
    var exp = Math.floor(Math.log(range) / Math.LN10), f = range / Math.pow(10, exp), nf;
    if (round) nf = f < 1.5 ? 1 : f < 3 ? 2 : f < 7 ? 5 : 10;
    else nf = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10;
    return nf * Math.pow(10, exp);
  }
  /* Axis for a bar chart whose tallest bar is dataMax: {max, step} with max the first tick at or above dataMax. */
  function niceScale(dataMax) {
    if (!(dataMax > 0)) return { max: 4, step: 1 };
    var step = niceNum(niceNum(dataMax, false) / 4, true);
    var max = Math.ceil(dataMax / step) * step;
    return { max: max, step: step };
  }
  function tickLabel(v) {
    if (v === 0) return '0';
    if (v >= 1000) return (v % 1000 === 0 ? v / 1000 : (v / 1000).toFixed(1)) + 'k';
    return String(v);
  }
  window.PCCarProblems = { compute: compute, niceScale: niceScale, tickLabel: tickLabel };

  var root = document.querySelector('[data-pc-cp]');
  if (!root) return;

  /* ---------- state ---------- */
  var doc = JSON.parse(root.querySelector('[data-pc-cp-doc]').textContent);
  var ctx = { make: root.getAttribute('data-make'), model: root.getAttribute('data-model'),
              acesMake: root.getAttribute('data-aces-make'), acesModel: root.getAttribute('data-aces-model'),
              partsLinks: root.getAttribute('data-parts-links') === 'true' };
  var name = ctx.make + ' ' + ctx.model;
  var q = function (s) { return root.querySelector(s); };
  var els = { chart: q('[data-pc-cp-chart]'), title: q('[data-pc-cp-year-title]'), rows: q('[data-pc-cp-rows]'),
              live: q('[data-pc-cp-live]'), prev: q('[data-pc-cp-prev]'), next: q('[data-pc-cp-next]'),
              toggle: q('[data-pc-cp-table-toggle]'), yearTable: q('[data-pc-cp-year-table]'),
              sideTitle: q('[data-pc-cp-side-title]'), sideN: q('[data-pc-cp-side-n]'), sideList: q('[data-pc-cp-side-list]'),
              sideRec: q('[data-pc-cp-side-rec]'), sideRecY: q('[data-pc-cp-side-recy]'), picker: q('[data-pc-cp-picker]') };
  var sel = root.getAttribute('data-worst-year');
  var fmt = function (n) { return Number(n).toLocaleString('en-US'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- render ---------- */
  function renderRows(r) {
    var html = '', i, x, link;
    for (i = 0; i < r.rows.length; i++) {
      x = r.rows[i];
      if (x.href && !x.bare) link = '<a class="pc-cp__btn pc-cp__btn--shop" href="' + esc(x.href) + '">Shop ' + esc(x.label.toLowerCase()) + ' parts<span class="pc-cp__sr"> for the ' + esc(r.year + ' ' + name) + '</span></a>';
      else if (x.href) link = '<a class="pc-cp__btn pc-cp__btn--shop pc-cp__btn--bare" href="' + esc(x.href) + '">Shop all ' + esc(x.label.toLowerCase()) + ' parts<span class="pc-cp__sr">, not filtered to this vehicle</span></a>';
      else if (x.mode === 'recall') link = '<a class="pc-cp__btn pc-cp__btn--ghost" href="https://www.nhtsa.gov/recalls" rel="noopener">Check recalls<span class="pc-cp__sr"> for ' + esc(x.label.toLowerCase()) + ' on NHTSA.gov</span></a>';
      else link = '<span class="pc-cp__none" aria-label="No parts link">—</span>';
      html += '<tr><th scope="row"><span class="pc-cp__cname">' + esc(x.label) + '</span>' + (x.parts && !x.hidden ? '<span class="pc-cp__sub">' + esc(x.parts) + '</span>' : '') + '</th>' +
        '<td><div class="pc-cp__share"><div class="pc-cp__track" aria-hidden="true"><div class="pc-cp__fill' + (x.hidden ? ' pc-cp__fill--dim' : '') + '" style="width:' + x.pct + '%"></div></div><span class="pc-cp__pct">' + x.pct + '%</span></div></td>' +
        '<td class="pc-cp__r" data-label="Filings">' + fmt(x.n) + '</td><td class="pc-cp__r" data-label="Crashes">' + fmt(x.crashes) + '</td><td>' + link + '</td></tr>';
    }
    els.rows.innerHTML = html;
  }
  function renderSide(r) {
    els.sideTitle.textContent = r.year + ' at a glance';
    els.sideN.textContent = fmt(r.n) + ' complaints';
    els.sideList.innerHTML = '<li><b>' + fmt(r.side.crash) + '</b> crashes and <b>' + fmt(r.side.fire) + '</b> fires reported</li><li><b>' + fmt(r.side.inj) + '</b> injuries</li>' +
      (r.side.miles ? '<li>Median failure mileage <b>' + fmt(r.side.miles) + '</b></li>' : '');
    els.sideRec.textContent = fmt(r.side.recalls); els.sideRecY.textContent = r.year;
  }
  function renderChart(r) {
    var W = Math.max(300, els.chart.parentNode.clientWidth - 20), narrow = W < 640;
    var H = narrow ? 240 : 300, padL = narrow ? 34 : 44, padR = 6, padT = 18, padB = 32;
    var dataMax = 0, i; for (i = 0; i < r.years.length; i++) if (r.years[i].n > dataMax) dataMax = r.years[i].n;
    // Axis fitted to the data: a round tick step (1, 2, 5 x 10^n) chosen for about four
    // gridlines, and the top tick just above the tallest bar, so 22 complaints fill the chart
    // instead of sitting under a 500 ceiling.
    var scale = niceScale(dataMax), max = scale.max, step = scale.step;
    var n = r.years.length, gap = narrow ? 2 : 6, bw = (W - padL - padR - gap * (n - 1)) / n, rad = Math.min(4, bw / 2);
    var y = function (v) { return padT + (H - padT - padB) * (1 - v / max); };
    var s = '', t, every = narrow ? 5 : 3, fs = narrow ? 10 : 11.5;
    for (t = 0; t <= max + step / 1000; t += step) {
      s += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + y(t) + '" y2="' + y(t) + '" stroke="#e9eaeb"/>' +
           '<text x="' + (padL - 6) + '" y="' + (y(t) + 4) + '" text-anchor="end" font-size="' + fs + '" fill="#6b7075" font-family="Barlow,sans-serif">' + tickLabel(t) + '</text>';
    }
    for (i = 0; i < n; i++) {
      var yr = r.years[i], x = padL + i * (bw + gap), top = y(yr.n), h = Math.max(y(0) - top, 2), isSel = yr.year === r.year;
      s += '<g class="pc-cp__bar" data-pc-cp-bar="' + yr.year + '" aria-hidden="true">' +
           '<rect x="' + (x - gap / 2) + '" y="' + padT + '" width="' + (bw + gap) + '" height="' + (H - padT - padB) + '" fill="transparent"/>' +
           '<path d="M' + x + ',' + y(0) + ' v' + (-(h - rad)) + ' a' + rad + ',' + rad + ' 0 0 1 ' + rad + ',-' + rad + ' h' + (bw - 2 * rad) + ' a' + rad + ',' + rad + ' 0 0 1 ' + rad + ',' + rad + ' v' + (h - rad) + ' z" fill="' + (isSel ? '#c8102e' : '#4d5257') + '"/>';
      if (isSel || (!narrow && yr.n >= max * 0.7)) s += '<text x="' + (x + bw / 2) + '" y="' + (top - 6) + '" text-anchor="middle" font-size="' + (narrow ? 11 : 12) + '" font-weight="600" fill="#17191b" font-family="Barlow,sans-serif">' + fmt(yr.n) + '</text>';
      if (i % every === 0 || isSel) s += '<text x="' + (x + bw / 2) + '" y="' + (H - 12) + '" text-anchor="middle" font-size="' + fs + '" fill="' + (isSel ? '#17191b' : '#6b7075') + '" font-weight="' + (isSel ? 700 : 400) + '" font-family="Barlow,sans-serif">’' + yr.year.slice(2) + '</text>';
      s += '</g>';
    }
    s += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + y(0) + '" y2="' + y(0) + '" stroke="#d7dadc"/>';
    els.chart.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    els.chart.innerHTML = s;
    var bars = els.chart.querySelectorAll('[data-pc-cp-bar]'), b;
    for (b = 0; b < bars.length; b++) {
      bars[b].addEventListener('click', onBar);
    }
  }
  function onBar() { select(this.getAttribute('data-pc-cp-bar'), true); }
  function select(year, announce) {
    var r = compute(doc, year, ctx); sel = r.year;
    els.title.textContent = 'What fails on the ' + r.year + ' ' + name;
    renderRows(r); renderSide(r); renderChart(r);
    var btns = root.querySelectorAll('[data-pc-cp-yearbtn]'), i;
    for (i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', String(btns[i].getAttribute('data-pc-cp-yearbtn') === r.year));
    els.prev.disabled = !r.prev; els.next.disabled = !r.next;
    if (announce) els.live.textContent = 'Showing ' + r.year + ': ' + fmt(r.n) + ' complaints.';
    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('year', r.year); window.history.replaceState(null, '', u.toString());
    }
  }

  /* ---------- picker (progressive: only shown when the lookup answers) ---------- */
  function initPicker() {
    var url = root.getAttribute('data-lookup-url');
    if (!url || !window.fetch || !els.picker) return;
    // The data date changes with each monthly run, so the lookup URLs change with it and no
    // browser keeps a make or model list from before a push.
    var v = '&v=' + encodeURIComponent(root.getAttribute('data-data-date') || '');
    var mk = els.picker.querySelector('[data-pc-cp-make]'), md = els.picker.querySelector('[data-pc-cp-model]'), yr = els.picker.querySelector('[data-pc-cp-year]');
    var models = [];
    fetch(url + '?s=makes' + v).then(function (r) { return r.json(); }).then(function (list) {
      var i; for (i = 0; i < list.length; i++) mk.insertAdjacentHTML('beforeend', '<option value="' + esc(list[i].make) + '">' + esc(list[i].label || list[i].make) + '</option>');
      els.picker.removeAttribute('hidden');
    }).catch(function () {});
    // The year list holds only the model years the chosen model has data for (from the lookup).
    function resetYears() { yr.innerHTML = '<option value="">Any year</option>'; yr.disabled = true; }
    function fillYears(years) {
      resetYears();
      var i; for (i = 0; i < years.length; i++) yr.insertAdjacentHTML('beforeend', '<option value="' + esc(String(years[i])) + '">' + esc(String(years[i])) + '</option>');
      yr.disabled = years.length === 0;
    }
    mk.addEventListener('change', function () {
      md.innerHTML = '<option value="">Model</option>'; md.disabled = true; resetYears();
      if (!mk.value) return;
      fetch(url + '?s=models&make=' + encodeURIComponent(mk.value) + v).then(function (r) { return r.json(); }).then(function (list) {
        models = list; var i;
        for (i = 0; i < list.length; i++) md.insertAdjacentHTML('beforeend', '<option value="' + esc(list[i].handle) + '">' + esc(list[i].model) + '</option>');
        md.disabled = false;
      }).catch(function () {});
    });
    md.addEventListener('change', function () {
      var i; for (i = 0; i < models.length; i++) if (models[i].handle === md.value) { fillYears(models[i].years || []); return; }
      resetYears();
    });
    els.picker.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!md.value) { md.focus(); return; }
      window.location.href = '/pages/car-problems/' + md.value + (yr.value ? '?year=' + yr.value : '');
    });
    resetYears();
  }

  /* ---------- init ---------- */
  // Use the attribute, not the .hidden property: SVGElement has no `hidden` IDL property, so
  // `svg.hidden = false` leaves the attribute in place and the chart stays display:none.
  function show(el) { el.removeAttribute('hidden'); }
  function hide(el) { el.setAttribute('hidden', ''); }
  show(els.chart); show(els.toggle); show(els.prev); show(els.next);
  hide(els.yearTable); els.toggle.setAttribute('aria-expanded', 'false');
  els.toggle.addEventListener('click', function () {
    var open = els.yearTable.hasAttribute('hidden'); if (open) show(els.yearTable); else hide(els.yearTable);
    els.toggle.setAttribute('aria-expanded', String(open)); els.toggle.textContent = open ? 'Hide table' : 'Show as table';
  });
  els.prev.addEventListener('click', function () { var r = compute(doc, sel, ctx); if (r.prev) select(r.prev, true); });
  els.next.addEventListener('click', function () { var r = compute(doc, sel, ctx); if (r.next) select(r.next, true); });
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-pc-cp-yearbtn]'); if (b) select(b.getAttribute('data-pc-cp-yearbtn'), true); });
  var stats = root.querySelectorAll('.pc-cp__stats .pc-cp__stat-v:not([data-no-format]), .pc-cp__stats .pc-cp__stat-n'), s;
  for (s = 0; s < stats.length; s++) if (/^\d+$/.test(stats[s].textContent.trim())) stats[s].textContent = fmt(stats[s].textContent.trim());
  var initial = (new URL(window.location.href)).searchParams.get('year') || sel;
  select(initial, false);
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { renderChart(compute(doc, sel, ctx)); }, 120); });
  initPicker();
})();
